export default {"src":"/_next/static/media/charging_icon.7cc42d71.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};